import { roundOf } from '@/utils'
import { PackageInfo } from '@/redux/package'
import { ANALYTICS_EVENTS, CART_TYPE, CartType } from './analytics.data'

export const getCartProducts = (currentPackage?: PackageInfo, include: CartType[] = []) => {
  if (!currentPackage) return { price: 0, items: [] }

  const {
    event,
    ticketInfo,
    hotelInfo,
    flightInfo,
    cartInfo: { ticket, hotel, flight, addons },
  } = currentPackage

  let price = 0
  const items: Array<object> = []

  if (include.includes(CART_TYPE.TICKET) && event && ticketInfo && ticket) {
    price += ticket.pricing.total.total
    items.push({
      item_id: event.id,
      item_name: event.name,
      item_category: ANALYTICS_EVENTS.CATEGORY.TICKETS,
      item_variant: currentPackage?.event.category?.subGenre ?? '',
      item_brand: ANALYTICS_EVENTS.PROVIDERS.TICKETS,
      quantity: ticket.quantity,
      price: ticket.pricing.total.total,
    })
  }

  if (include.includes(CART_TYPE.HOTEL) && hotelInfo && hotel) {
    price += hotel.pricing.total.total
    items.push({
      item_id: hotelInfo.id,
      item_name: hotelInfo.name,
      item_category: ANALYTICS_EVENTS.CATEGORY.HOTELS,
      item_variant: hotelInfo.roomAndRateInfo.name,
      item_brand: hotelInfo.roomAndRateInfo.providerName,
      quantity: hotel.totalPersons,
      price: hotel.pricing.total.total,
    })
  }

  if (include.includes(CART_TYPE.FLIGHT) && flightInfo?.departure && flight) {
    const isRoundTrip = !!flightInfo.return && Object.keys(flightInfo.return).length > 0
    const flightTotal = flight.pricing.total.total
    const legPrice = isRoundTrip ? flightTotal / 2 : flightTotal

    price += flightTotal

    items.push({
      item_id: flightInfo.departure.itineraries,
      item_name: flightInfo.airlines[flightInfo.departure.operatingAirline].name,
      item_category: ANALYTICS_EVENTS.CATEGORY.FLIGHTS,
      item_variant: flightInfo.departure.class,
      item_brand: ANALYTICS_EVENTS.PROVIDERS.FLIGHTS,
      quantity: flight.totalPersons,
      price: legPrice,
    })

    if (isRoundTrip) {
      items.push({
        item_id: flightInfo.return.itineraries,
        item_name: flightInfo.airlines[flightInfo.return.operatingAirline].name,
        item_category: ANALYTICS_EVENTS.CATEGORY.FLIGHTS,
        item_variant: flightInfo.return.class,
        item_brand: ANALYTICS_EVENTS.PROVIDERS.FLIGHTS,
        quantity: flight.totalPersons,
        price: legPrice,
      })
    }
  }

  if (include.includes(CART_TYPE.ADDONS) && addons && addons.length > 0) {
    addons.forEach((addon) => {
      price += addon.pricing.total.total
      items.push({
        item_id: addon.details.id,
        item_name: addon.details.name,
        item_category: ANALYTICS_EVENTS.CATEGORY.ADDONS,
        item_variant: 'Miscellaneous',
        item_brand: ANALYTICS_EVENTS.PROVIDERS.ADDONS,
        price: addon.pricing.total.total,
        quantity: addon.quantity,
      })
    })
  }

  return { price: roundOf(price), items }
}
